import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { connect } from 'react-redux';
import get from 'lodash/get';

import { LEFT, CENTER, RIGHT, NONE_TYPE, LOGO_TYPE, MEDIUM } from 'common/entities/form/styleConfiguration/constants';
import { DEFAULT_LOGO_SIZES, DEFAULT_LOGO_POSITION } from 'common/entities/form/styleConfiguration/defaultValues';
import { formLogoPaddingTop, formLogoPaddingBottom } from 'common/styles/variables';
import { getFormHeaderImageStyles } from 'common/entities/form/styleConfiguration/selectors';
import { withFormId } from '../FormIdContext';

const POSITION_TO_DISPLAY = {
    [LEFT]: 'flex-start',
    [CENTER]: 'center',
    [RIGHT]: 'flex-end',
};

const HeaderImageContainer = styled.div`
    display: flex;
    justify-content: ${(props) => POSITION_TO_DISPLAY[props.position]};
    padding-top: ${formLogoPaddingTop};
    padding-bottom: ${formLogoPaddingBottom};
`;

const HeaderImage = styled.img`
    height: ${(props) => `${props.height}rem`};
    width: auto;
    object-fit: contain;
`;

const BASE_COMPONENT_NAME = 'FormLogo';

const FormLogo = ({ imageUrl, imageType, imageSize, imagePosition, imageAltText }) =>
    imageType === LOGO_TYPE && imageUrl ? (
        <HeaderImageContainer data-qa={`${BASE_COMPONENT_NAME}__container`} position={imagePosition}>
            <HeaderImage src={imageUrl} height={imageSize} alt={imageAltText} />
        </HeaderImageContainer>
    ) : null;

FormLogo.propTypes = {
    imageUrl: PropTypes.string,
    imageAltText: PropTypes.string,
    imageSize: PropTypes.number.isRequired,
    imageType: PropTypes.string.isRequired,
    imagePosition: PropTypes.oneOf([LEFT, CENTER, RIGHT]).isRequired,
};

FormLogo.defaultProps = {
    imageUrl: null,
    imageAltText: '',
};

const mapStateToProps = (state, props) => {
    const { formId } = props;
    const {
        size,
        url: imageUrl,
        type: imageType = NONE_TYPE,
        position: imagePosition = DEFAULT_LOGO_POSITION,
        altText: imageAltText,
    } = getFormHeaderImageStyles(state, formId);

    return {
        imageSize: get(DEFAULT_LOGO_SIZES, `${size}.value`, DEFAULT_LOGO_SIZES[MEDIUM].value),
        imageUrl,
        imageType,
        imagePosition,
        imageAltText,
    };
};

const mapDispatchToProps = {};

export default withFormId(connect(mapStateToProps, mapDispatchToProps)(FormLogo));
